import { USD_DECIMALS } from '@ui/constants/numbersDecimals';
import { toReadableValue } from '@ui/lib/bignumber';

import type { DecreaseOrderRow } from './types';

export const getActiveDecreaseOrders = (
  orders: DecreaseOrderRow[] | undefined,
) => {
  return (orders ?? []).filter((order) => order.status === 'ACTIVE');
};

export const getActiveDecreaseOrdersByPositionHash = (
  orders: DecreaseOrderRow[] | undefined,
) => {
  return getActiveDecreaseOrders(orders).reduce<
    Record<string, DecreaseOrderRow[]>
  >((acc, order) => {
    acc[order.positionHash] ??= [];
    acc[order.positionHash].push(order);

    return acc;
  }, {});
};

export const getActiveTpOrders = (orders: DecreaseOrderRow[] | undefined) => {
  return getActiveDecreaseOrders(orders)
    .filter((order) => order.kind === 'TP')
    .sort((a, b) => Number(a.triggerPrice - b.triggerPrice));
};

export const getActiveSlOrders = (orders: DecreaseOrderRow[] | undefined) => {
  return getActiveDecreaseOrders(orders)
    .filter((order) => order.kind === 'SL')
    .sort((a, b) => Number(a.triggerPrice - b.triggerPrice));
};

export const getDecreaseOrderTriggerPrice = (order?: DecreaseOrderRow) => {
  if (!order) return undefined;

  return toReadableValue(order.triggerPrice, USD_DECIMALS);
};

